import { render, staticRenderFns } from "./EmployeeTransfer.vue?vue&type=template&id=3ebf1804&"
import script from "./EmployeeTransfer.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTransfer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports